import { stateAbbreviations } from "../constants/StateAbbreviations";

/**
 * AB#33920 / AB#22183: Tempo expects 2-letter state codes (e.g. Tennessee → TN).
 * Mirrors ConnectUI's matchState: matches a 2-letter code or a full/partial state
 * name (case-insensitive). Unmatched input is returned unchanged; empty input returns null.
 */
export const matchState = (input: string | null | undefined): string | null => {
  if (input) {
    const normalizedInput = input.trim().toLowerCase();

    // Direct match for abbreviations
    if (stateAbbreviations[normalizedInput.toUpperCase()]) {
      return stateAbbreviations[normalizedInput.toUpperCase()];
    }

    // Match for full or partial state names
    const matchedState = Object.keys(stateAbbreviations).find((state) =>
      state.toLowerCase().startsWith(normalizedInput)
    );

    return matchedState ? stateAbbreviations[matchedState] : input;
  }
  return null;
};

/**
 * Returns a copy of the address with patientState converted via matchState.
 * Empty states are kept as-is; null/undefined addresses become null.
 */
export function withMatchedPatientState<T extends { patientState: string }>(
  address: T
): T;
export function withMatchedPatientState<T extends { patientState: string }>(
  address: T | null | undefined
): T | null;
export function withMatchedPatientState<T extends { patientState: string }>(
  address: T | null | undefined
): T | null {
  if (!address) {
    return null;
  }
  return {
    ...address,
    patientState: matchState(address.patientState) ?? address.patientState,
  };
}
